export enum TopBarDataEventObject {
  BOOK_A_SETUP_CALL = 'book_a_setup_call',
  COMMUNITY = 'community',

  HELP_WIDGET_OPEN = 'help_widget_open',
  HELP_WIDGET_CLOSE = 'help_widget_close',
  HELP_WIDGET_ADMIN_COMMAND_CENTER_P0_SUGGESTIONS_TAB = 'help_widget_admin_command_center_p0_suggestions_tab',
  HELP_WIDGET_HELP_TAB = 'help_widget_help_tab',
  HELP_WIDGET_PRODUCT_UPDATES_TAB = 'help_widget_product_updates_tab',
  HELP_WIDGET_PRODUCT_UPDATES_OPEN_ARTICLE = 'help_widget_product_updates_open_article',
  HELP_WIDGET_PRODUCT_UPDATES_DISMISS = 'help_widget_product_updates_dismiss',
  HELP_WIDGET_PRODUCT_UPDATES_SEE_MORE = 'help_widget_product_updates_see_more',

  LEFT_PANEL_REVEAL = 'left_panel_reveal',
}
